import { DadataRepository } from './dadata.repository';
import { IDadataRepository } from '../../domain/repositories/dadata.repository';

export const createDadataRepository = (): IDadataRepository => {
  return new DadataRepository('e2e2632d06e080aad5e8c1d5fd10056c0e08a341');
};
